import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { PendingUpload } from 'alurkerja-ui'
import _ from 'lodash'
import { useContext } from 'react'
import { Controller } from 'react-hook-form'

export const specUploadBuktiPendukung = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Bukti Pendukung',
    name: 'supported_file',
    type: 'file',
  },
]

export default function UploadBuktiPendukungField() {
  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)

  return (
    <div>
      <label htmlFor="supported_file" className={'font-medium'}>
        Bukti Pendukung
      </label>
      <Controller
        name={'supported_file'}
        control={control}
        render={({ fieldState }) => {
          return (
            <>
              <PendingUpload
                asFile
                multiple={false}
                onChange={e => {
                  if (_.isArray(e)) setValue('supported_file', _.first(e))
                }}
                allowedExtension={['jpg', 'jpeg', 'png', 'pdf']}
              />
              {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
            </>
          )
        }}
      ></Controller>
    </div>
  )
}
